module.exports = __webpack_public_path__ + "media/contractor-reporting/automatic-hours-tracking-4c6c52c6.png";